<tidy-image class="body-size"
  [src]="'assets/svg/arrow-redo-circle.svg'">
</tidy-image>
<tidy-text
  [body]="redoBodyText">
</tidy-text>
